import { get, patch } from "@readai/common/api";
import {
  CRMRecommendation,
  CRMRecommendationPatchBody,
  CRMUserAction,
} from "@readai/common/types/crmRecommendationsTypes";

export const listRecommendations = async (
  excludedActions?: CRMUserAction[],
): Promise<CRMRecommendation[]> => {
  const params = new URLSearchParams();
  if (excludedActions) {
    excludedActions.forEach((action) =>
      params.append("user_action_exclude", action),
    );
  }
  return get(`/crm-recommendations?${params}`, {
    withCreds: true,
  });
};

export const patchRecommendations = async (patchRecommendation: {
  id: string;
  body: CRMRecommendationPatchBody;
}) => {
  return patch(
    `/crm-recommendations/${patchRecommendation.id}`,
    patchRecommendation.body,
    {
      withCreds: true,
    },
  );
};
